import React, { useEffect, useMemo, useState } from "react";
//Components
import Loader from "../generics/Loader";
import { Visibility } from "components/Visibility";
import TabNavigation from "components/TabNavigation";
import TableDetails from "../generics/Tables/Details/TableDetails";
import { eventName } from "components/ApplicationInsights/eventNames";
import { ButtonRow, CustomButton, CustomButtonText, LoaderContainer } from "./styles";
//Models
import { ITabProps } from "models/QuoteDetail";
//interfaces
import { CategoryTabProps, IQuoteCategoryTab, quoteHeaderLabels } from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";

export const QuoteCategoryTab: React.FC<IQuoteCategoryTab> = (props) => {
  const {
    state,
    quoteId,
    hasMore,
    setHasMore,
    refreshItem,
    customerCode,
    isNoSegmented,
    showDeParaModal,
    productSelected,
    segmentSelected,
    updateQuoteStatus,
    setRefreshControl,
    setProductSelected,
    setSegmentSelected,
    distributionCenters,
    setOldSegmentSelected,
    setRemoveAllFromToSegment,
    reproveMapProduct,
    approveMapProduct
  } = props;

  const [segmentFilter, setSegmentFilter] = useState('');
  const [oldTabs, setOldTabs] = useState<ITabProps[]>([]);
  const [firstDetailPageRender, setFirstDetailPageRender] = useState<boolean>(false);
  const {
    quoteItem,
    quoteDetail,
    currentPage,
    setQuoteItem,
    firstLoadPage,
    setCurrentPage,
    setFirstLoadPage,
    secondDetailPageRender,
  } = useDetailsQuoteContext();

  const refreshTableWithTab = (tabs: any) => {
    setSegmentSelected(tabs[0].segmentTab);
    setHasMore(true);
    setCurrentPage(0);
    setFirstLoadPage(true);
    setQuoteItem(undefined);
    setFirstDetailPageRender(false);
    setRemoveAllFromToSegment(true);
  };

  const MemoQuoteDetailsTable = useMemo(() => (
    <TableDetails
      customProps={{
        getDetail: updateQuoteStatus,
        getNewItem: refreshItem,
        showModal: showDeParaModal
      }}
      state={state}
      quoteId={quoteId}
      setHasMore={setHasMore}
      customerCode={customerCode}
      isNoSegmented={isNoSegmented}
      segmentFilter={segmentFilter}
      headerLabels={quoteHeaderLabels}
      productSelected={productSelected}
      setRefreshControl={setRefreshControl}
      setProductSelected={setProductSelected}
      refreshTableWithTab={refreshTableWithTab}
      distributionCenters={distributionCenters}
      reproveMapProduct={reproveMapProduct}
      approveMapProduct={approveMapProduct}
    />
  ), [quoteItem, currentPage, customerCode, distributionCenters, segmentSelected, productSelected]);

  const tabsRender = useMemo(() => {
    const tabs: CategoryTabProps[] = [];

    quoteDetail?.tabs.map((tab: ITabProps) => {
      const tabLabel = tab.segmentTabDescription;
      const tabCategory = tab.segmentTab;
      const itemQuantity = tab.count;

      tabs.push({
        filter: tabCategory,
        trackingName: tabCategory,
        label: `${tabLabel} (${itemQuantity})`
      });
    });

    return tabs;
  }, [quoteDetail]);

  useEffect(() => {
    if (quoteDetail) {
      const indexOldSegmentSelected = tabsRender.find(x => x.filter === segmentSelected);

      if (oldTabs.length !== tabsRender.length || ((oldTabs.length === tabsRender.length) && (oldTabs[0].segmentTab !== tabsRender[0].filter)) || !indexOldSegmentSelected) {
        setOldTabs(quoteDetail.tabs);
        setOldSegmentSelected(segmentSelected);
        setFirstDetailPageRender(true);
      }
    }
  }, [quoteDetail]);

  useEffect(() => {
    setFirstDetailPageRender(true);
  }, []);

  useEffect(() => {
    if (segmentSelected !== '') {
      setSegmentFilter(segmentSelected);
      segmentFilter !== segmentSelected && setFirstDetailPageRender(true);
    }
  }, [segmentSelected]);

  useEffect(() => {
    if (segmentFilter !== segmentSelected) {
      setHasMore(true);
      setCurrentPage(0);
      setFirstLoadPage(true);
      setQuoteItem(undefined);
      setFirstDetailPageRender(false);
      setRemoveAllFromToSegment(true);
      setSegmentSelected(segmentFilter);
    }
  }, [segmentFilter]);

  return (
    <>
      <Visibility visible={!isNoSegmented}>
        <TabNavigation
          singlePage
          className="mt-3"
          portalNavigation
          tabLabels={tabsRender ?? []}
          pages={[MemoQuoteDetailsTable]}
          trackingKey="Edição de cotações"
          trackingEvent={eventName.COTACOES}
          firstDetailPageRender={firstDetailPageRender}
          setTabFilter={(filter) => setSegmentFilter(filter)}
        />
      </Visibility>

      <Visibility visible={isNoSegmented}>
        {MemoQuoteDetailsTable}
      </Visibility>

      <Visibility visible={hasMore && secondDetailPageRender && !firstLoadPage}>
        <ButtonRow>
          <CustomButton onClick={() => { setCurrentPage(currentPage + 1); }}>
            <CustomButtonText>
              Carregar mais itens
            </CustomButtonText>
          </CustomButton>
        </ButtonRow>
      </Visibility>

      <Visibility visible={!secondDetailPageRender && !firstLoadPage}>
        <LoaderContainer>
          <Loader size={!quoteItem ? 45 : 35} />
        </LoaderContainer>
      </Visibility>
    </>
  );
};